import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {denim, grayscale} from '/theme/color/on.color';
import {green, orangeRed} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  container: {flexGrow: 1},

  header: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: indent * 0.7,
    marginBottom: indent,
    marginLeft: indent,
    marginRight: indent * 0.8,
  },
  headerText: {
    fontWeight: 'bold',
    fontSize: 16,
    flex: 1,
  },
  showHideButtonContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  showHideButton: {
    color: denim,
    marginRight: indent / 2,
  },
  icon: {
    fontSize: 18.5,
    fontWeight: '600',
    alignSelf: 'flex-end',
  },
  textLabel: {
    fontSize: 14,
    paddingLeft: indent * 0.2,
    paddingTop: indent * 0.6,
  },
  positiveLabel: {
    color: green,
  },
  negativeLabel: {
    color: orangeRed,
  },
  gainedWeightLabel: {
    color: grayscale,
  },
});
